/**
 * TODO: DEPRECATED - Legacy Tank API
 *
 * This file contains legacy callback-style API functions.
 * Use tank.service.ts instead for new code.
 *
 * Migration:
 * - getTankList() → getTanks() from tank.service.ts
 * - getTankById() → getTankById() from tank.service.ts (async version)
 *
 * @deprecated Use @/api/tank/tank.service.ts instead
 */

import { TankType } from '../../types/apiResponse/tankSpecTypes'
import { getData } from '../../utils'
import type { TankListResponse } from '../../types/apiResponse/tankTypes'

/**
 * @deprecated Use getTankById() from tank.service.ts instead
 *
 * Fetches single tank by ID
 * Backend endpoint: GET /tank/{tankId}
 */
export const getTankById = async (tankId: string) => {
  return await getData<TankType>(`tank/${tankId}`)
}

/**
 * @deprecated Use getTanks() from tank.service.ts instead
 *
 * Fetches tank list
 * Backend endpoint: GET /tank
 *
 * @param setState - Callback to update state with response data
 */
export const getTankList = (setState: (tankResponse: TankListResponse) => void) => {
  getData<{ success: number; data: TankListResponse }>('tank').then((response) => {
    const data = (response as any).data || response
    setState(data)
  })
}
